import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { getResolvedAttributes } from '@atlaskit/link-analytics/resolved-attributes';
import { useSmartCardState as useSmartLinkState } from '../../state/store';
import { LinkAnalyticsContext } from './LinkAnalyticsContext';
/**
 * Provides an analytics context to supply attributes to events based on a URL
 * and the link state in the store
 */
export var SmartLinkAnalyticsContext = function SmartLinkAnalyticsContext(props) {
  var children = props.children,
    url = props.url,
    display = props.display;
  var _useSmartLinkState = useSmartLinkState(url),
    details = _useSmartLinkState.details,
    status = _useSmartLinkState.status;
  var attributes = getResolvedAttributes({
    url: url
  }, details, status);
  return /*#__PURE__*/React.createElement(LinkAnalyticsContext, _extends({}, props, {
    display: display
  }), /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      attributes: attributes
    }
  }, children));
};